/**
 * Created by r4zi4l on 18.03.2021
 */

const EnergyLotteryWindow = CleverappsWindow.extend({
    onWindowLoaded: function (lottery) {
        this.lottery = lottery;

        this.lottery.on("play", this.createListener(this.play.bind(this)));
        this.lottery.on("finish", this.createListener(this.finish.bind(this)));
        this.lottery.on("prepareNext", this.createListener(this.prepareAxe.bind(this)));

        this._super({
            name: "EnergyLotteryWindow",
            content: this.createContent(),
            noBackground: true,
            closeButton: true,
            notCloseByTouchInShadow: true
        });

        this.prepareAxe();

        this.lottery.start();
    },

    getPerson: function () {
        return cleverapps.persons.choose("seller") ? {
            role: "seller",
            emotion: "idle"
        } : "worker";
    },

    createContent: function () {
        const styles = cleverapps.styles.EnergyLotteryWindow;

        const background = new cleverapps.Spine(bundles.energylottery.jsons.energy_lottery_json);
        background.setAlignment(styles.background);
        background.setAnimation(0, "animation", true);

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize2(styles);
        container.addChild(background);

        const field = this.createField();
        field.setAlignment(styles.field);
        container.addChild(field);

        const title = cleverapps.UI.generateOnlyText(Messages.get("EnergyLotteryWindow.title"), cleverapps.styles.FONTS.ENERGY_LOTTERY_TITLE_TEXT);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width, styles.title.height);
        container.addChild(title);

        const descriptionKey = "EnergyLotteryWindow.description";
        const description = cleverapps.UI.generateOnlyText(Messages.get(descriptionKey), cleverapps.styles.FONTS.ENERGY_LOTTERY_DESCRIPTION_TEXT);
        description.setAlignment(styles.description);
        description.fitTo(styles.description.width, styles.description.height);
        container.addChild(description);

        const axe = this.axe = new cleverapps.Spine(bundles.energylottery.jsons.energy_lottery_axe_json);
        axe.setLocalZOrder(10);
        container.addChild(axe);

        return container;
    },

    createField: function () {
        const styles = cleverapps.styles.EnergyLotteryWindow.field;

        this.icons = [];
        for (let i = 0; i < this.lottery.getValues().length; i++) {
            this.icons.push(this.createLotIcon());
        }

        return new cleverapps.GridLayout(this.icons, {
            columns: 3,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    createLotIcon: function () {
        const styles = cleverapps.styles.EnergyLotteryWindow.icon;

        const icon = new cc.Node();
        icon.setAnchorPoint(0.5, 0.5);
        icon.setContentSize2(styles);

        const animation = icon.animation = new cleverapps.Spine(bundles.energylottery.jsons.energy_lottery_icon_json);
        animation.setAlignment(icon.width / 2, icon.height / 2);
        animation.setSkin("lottery");
        animation.setAnimation(0, "idle", true);
        icon.addChild(animation);

        cleverapps.UI.applyHover(icon);
        cleverapps.UI.onClick(icon, this.lottery.play.bind(this.lottery, { icon }));

        return icon;
    },

    prepareAxe: function () {
        const styles = cleverapps.styles.EnergyLotteryWindow;

        this.axe.setVisible(false);
        this.axe.setAlignment(styles.axe);
        this.axe.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.Show(),
            new cc.CallFunc(this.axe.setAnimationAndIdleAfter.bind(this.axe, "axe_emergence", "axe_idle"))
        ));
    },

    play: function (options) {
        const icon = options.icon;

        cleverapps.pointerManager.removeAll(icon);

        icon.opened = true;

        this.throwAxe(options);
    },

    finish: function () {
        this.icons.forEach((icon) => {
            cleverapps.pointerManager.removeAll(icon);
            if (!icon.opened) {
                icon.animation.setAnimationAndIdleAfter("close", "idle_closed");
            }
        });
    },

    throwAxe: function (options) {
        const icon = options.icon;
        const [type, value] = Object.entries(options.amount)[0];

        cleverapps.effects.fire("energylottery.lot.open");

        const axe = this.axe;
        axe.stopAllActions();
        axe.setAnimation(0, "axe_crash1", false);
        axe.setCompleteListener(() => {
            const offset = cleverapps.styles.EnergyLotteryWindow.axe.target.offset;
            const iconPosition = cc.Base.GetTargetPosition(axe, icon);

            axe.setCompleteListener();
            axe.setAnimation(0, "axe_crash2", false);
            axe.runAction(new cc.Sequence(
                new cc.MoveTo(0.5667, iconPosition.x + offset.x, iconPosition.y + offset.y),
                new cc.CallFunc(() => {
                    this.axe.setVisible(false);
                    icon.animation.setAnimationAndIdleAfter("crash", "idle_crashed");
                    icon.setLocalZOrder(1);

                    if (cleverapps.config.name === "mergecraft") {
                        const rewardIcon = new Reward(type, value).getSmallIcon();
                        rewardIcon.setAlignment(cleverapps.styles.EnergyLotteryWindow.icon);
                        icon.addChild(rewardIcon);
                    }

                    const rewardAmount = cleverapps.UI.generateImageText(value, cleverapps.styles.FONTS.ENERGY_LOTTERY_VALUE_TEXT);
                    rewardAmount.setAlignment(cleverapps.styles.EnergyLotteryWindow.icon.reward);
                    icon.addChild(rewardAmount);

                    this.lottery.onAnimationFinished();
                })
            ));
        });

        Map2dLocation.currentLocation.addReward(type, value, icon, {
            delay: (axe.getTimeLeft() + 0.5667) * 1000,
            event: "lottery"
        });
    },

    listBundles: function () {
        return ["energylottery"];
    }
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    ENERGY_LOTTERY_STROKE: {
        color: new cc.Color(95, 29, 17, 255),
        size: 1
    },

    ENERGY_LOTTERY_SHADOW: {
        color: new cc.Color(11, 13, 37, 128),
        direction: cc.size(0, -3),
        blur: 4
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ENERGY_LOTTERY_TITLE_TEXT: {
        size: 78,
        color: new cc.Color(255, 201, 39, 255),
        stroke: cleverapps.styles.DECORATORS.ENERGY_LOTTERY_STROKE,
        shadow: cleverapps.styles.DECORATORS.ENERGY_LOTTERY_SHADOW
    },
    ENERGY_LOTTERY_DESCRIPTION_TEXT: {
        size: 34,
        color: new cc.Color(255, 220, 132, 255),
        stroke: cleverapps.styles.DECORATORS.ENERGY_LOTTERY_STROKE,
        shadow: cleverapps.styles.DECORATORS.ENERGY_LOTTERY_SHADOW
    },
    ENERGY_LOTTERY_VALUE_TEXT: {
        size: 40,
        color: new cc.Color(122, 232, 255, 255),
        stroke: cleverapps.styles.DECORATORS.ENERGY_LOTTERY_STROKE
    }
});

cleverapps.styles.EnergyLotteryWindow = {
    width: 1200,
    height: 1000,

    background: {
        x: { align: "center" },
        y: { align: "center", dy: -45 }
    },

    field: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -28 },

        margin: {
            x: 50,
            y: 50
        },

        padding: {
            x: 30,
            y: 30
        }

    },

    icon: {
        width: 150,
        height: 150,

        x: { align: "center" },
        y: { align: "center", dy: 2 },

        reward: {
            x: { align: "center" },
            y: { align: "center", dy: -17 }
        }
    },

    title: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 396 },
        width: 600,
        height: 90
    },

    description: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 306 },
        width: 400,
        height: 50
    },

    axe: {
        x: { align: "right", dx: 170 - 15 },
        y: { align: "bottom", dy: -310 - 50 },
        target: {
            offset: {
                x: 709,
                y: -465
            }
        }
    }
};
